var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeIdBreathFreq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BoxContent/Header/LeftIcon31") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon31",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F7",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "lung-2",
    transform: "translate(4.000000, 5.000000)",
    fill: "#181E34",
    opacity: 0.400000006
  }, /*#__PURE__*/React.createElement("g", {
    id: "lung"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,-4.6629367e-14 C8.41424306,-4.6629367e-14 8.75130435,0.333700144 8.75130435,0.743812417 L8.75130435,0.743812417 L8.75196369,4.04975904 C8.75992939,4.57121381 8.85400724,4.84252347 9.75056477,4.84252347 L9.6168541,4.83920289 C9.70456566,3.05539035 10.1121202,1.16972477 11.7237596,1.16972477 C14.0429979,1.16972477 15.9998471,7.23768461 15.9998471,11.0486555 L15.9998471,11.0486555 L15.9994743,11.1910969 C15.9934602,11.7948259 15.9241143,14.0928638 15.2272815,14.7850728 C15.0836619,14.9275981 14.9200024,15 14.7406706,15 C14.2665203,15 14.0307941,14.8215269 13.7043742,14.5745758 C13.2949684,14.2650957 12.7342353,13.8408107 11.3117846,13.4366513 C9.04143721,12.7916761 9.13012433,10.7841786 9.36989455,8.58731142 L9.41608292,8.17346607 C9.48458296,7.56591126 9.55494583,6.94221935 9.58288696,6.3267046 C8.91644871,6.30323342 8.38427219,6.13561043 7.99961537,5.82788452 C7.58293634,6.16133081 6.9939445,6.33027523 6.24969165,6.33027523 L6.4170443,6.32671924 C6.44495893,6.94226317 6.51528403,7.56600965 6.58397926,8.17346607 C6.84961952,10.527919 7.10023081,12.7513651 4.6884022,13.4366513 C3.26578813,13.8408107 2.70522038,14.2650957 2.29571305,14.5748289 C1.96931464,14.8215269 1.73360386,15 1.25948481,15 C1.08003633,15 0.916387544,14.9275981 0.772777383,14.7850728 C0.0758768143,14.0928638 0.00662292669,11.7947268 0.000541972892,11.1903616 L0.00013416322,11.0476429 C0.00013416322,7.23755804 1.95698318,1.16972477 4.27619736,1.16972477 C5.88751384,1.16972477 6.29528285,3.05539035 6.3830688,4.83920289 C7.20656783,4.81126446 7.24869565,4.50694687 7.24869565,3.94906005 L7.24869565,3.94906005 L7.24869565,0.743812417 C7.24869565,0.333700144 7.58575694,-4.6629367e-14 8,-4.6629367e-14 Z",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeIdBreathFreq);
export default __webpack_public_path__ + "static/media/life_id-breath-freq.7d82c3309e8a6566a21536e76beedf1e.svg";
export { ForwardRef as ReactComponent };